__turbopack_context__.v({
  "className": "quicksand_4317cf60-module__FqhsNG__className",
});
